/**
 * assert
 * @param cond condition expect to meet
 * @param message message to throw shen condition is not met
 */
export function assert(cond: boolean, message?: string): void {
  if (!cond) {
    throw new Error(`assert failure: ${message}`);
  }
}
